module.exports = __webpack_public_path__ + "static/media/LTT_shells_logos.78d76031.png";